import classNames from 'classnames';
import { Tile } from 'common/tile/tile.js';
import { AdvertFuseModuleTargetingHook } from 'components/advert/ad-targeting/advert-targeting.js';
import { AdvertErrorBoundary } from 'components/advert/advert-error-boundary.js';
import { AdvertFuse } from 'components/advert/advert-fuse.js';
import { IAdCoreProps } from 'components/advert/types.js';
import { useCallback, useState } from 'react';
import { IApiAdTargeting } from 'redux-state/advertisement/types.js';
import { IModule } from 'redux-state/layout/types.js';
import { isDevEnv } from 'utilities/consts/webpack-consts.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { modulePathIsPrimaryLeft, modulePathIsPrimaryRight } from 'utilities/modulePath/layout-modulepath.js';

export type IAdvertProps = IAdCoreProps & {
  // We rename here as this comes from server
  mergeBaseTargeting?: boolean;
  override: boolean;
  targeting?: IApiAdTargeting[];
  unit?: string;
  forceMrecSpace?: boolean;
};

export const AdvertModule = (props: IModule<IAdvertProps>) => {
  const { config, modulePath } = props;
  const [adPopulated, _setAdPopulated] = useState(false);

  const setAdPopulated = useCallback(() => {
    _setAdPopulated(true);
  }, []);

  if (!config.adUnitPath || !config.unit) {
    if (isDevEnv(false)) {
      messageLog.info(`Module ad config is incorrect: ${config}`);
    }
    return null;
  }

  const { targeting, override, mergeBaseTargeting } = config;

  const isLeft = modulePathIsPrimaryLeft(modulePath);
  const isRight = modulePathIsPrimaryRight(modulePath);

  const classes = classNames('Tile--noShadow', {
    'u-textRight': isRight,
    'u-textLeft': isLeft,
    'u-sm-textCenter u-md-textCenter': isRight || isLeft,
    'Tile--hide-empty': !adPopulated,
  });

  const finalTargeting = AdvertFuseModuleTargetingHook({
    overrideBaseTargeting: override,
    mergeBaseTargeting: mergeBaseTargeting ?? false,
    targeting,
    queryParams: undefined,
  });

  return (
    <Tile dataModule="advert-mod" {...props} classes={classes}>
      <AdvertErrorBoundary>
        <AdvertFuse
          fuseTag={config.fuseTag}
          adUnitPath={config.adUnitPath}
          forceMrecSpace={config.forceMrecSpace}
          targeting={finalTargeting}
          adDisplayTrueCB={setAdPopulated}
          origin={`adv-Module: ${modulePath}`}
        />
      </AdvertErrorBoundary>
    </Tile>
  );
};
